export const sanitizeValue = (value) => {
  if (!value) {
    return ''
  }
  const trimmed = String(value).trim()
  if (!trimmed || trimmed === 'null' || trimmed === 'undefined') {
    return ''
  }
  return trimmed
}

export const normalizeUrl = (url) => {
  const sanitized = sanitizeValue(url)
  if (!sanitized) {
    return null
  }
  return /^https?:\/\//i.test(sanitized) ? sanitized : `https://${sanitized}`
}

export const handlePhoneClick = (phone) => {
  const phoneCorrection = sanitizeValue(phone)
  if (!phoneCorrection) {
    return
  }
  window.location.href = `tel:${phoneCorrection}`
}

export const handleMailClick = (mail, name = 'Supplier') => {
  const email = sanitizeValue(mail)
  if (!email) {
    return
  }
  const subject = 'Service Request'
  const body = `Dear ${name},\n\nI would like to request a quotation for the delivery of your services.\n\nPlease let me know the details and availability.\n\nBest regards,\n[Your Name]`
  window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}

export const readSupplierAssignment = () => {
  if (typeof window === 'undefined') {
    return {
      supplierId: '',
      supplierName: '',
      supplierPhone: '',
    }
  }
  return {
    supplierId: window.localStorage.getItem('supplierid') ?? '',
    supplierName: window.localStorage.getItem('suppliername') ?? '',
    supplierPhone: window.localStorage.getItem('suppliertel') ?? '',
  }
}

export const writeSupplierAssignment = ({ supplierId, supplierName, supplierPhone }) => {
  if (typeof window === 'undefined') {
    return
  }
  if (supplierId !== undefined) {
    window.localStorage.setItem('supplierid', supplierId ?? '')
  }
  if (supplierName !== undefined) {
    window.localStorage.setItem('suppliername', supplierName ?? '')
  }
  if (supplierPhone !== undefined) {
    window.localStorage.setItem('suppliertel', supplierPhone ?? '')
  }
}

export const clearSupplierAssignment = () => {
  writeSupplierAssignment({ supplierId: '', supplierName: '', supplierPhone: '' })
}

export const filterManualSuppliers = (manualSuppliers = []) => {
  return manualSuppliers.filter((manual) => {
    const values = [
      manual?.supplier_name,
      manual?.supplier_contact_name,
      manual?.supplier_contact_tel,
      manual?.supplier_contact_mail,
    ]
    return values.some((value) => sanitizeValue(value))
  })
}

export const filterPreferredSuppliers = (preferredSuppliers = []) => {
  return preferredSuppliers.filter((supplier) => {
    const values = [supplier?.supplierName, supplier?.supplierMail, supplier?.supplierPhone]
    return values.some((value) => sanitizeValue(value))
  })
}
